import { UniformConfluencePricingEntryPage } from 'src/pages/uniform-entry/uniform-confluence-pricing-entry-page.tsx';

import { init } from '../../init-streaming';
init(UniformConfluencePricingEntryPage);
